import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { get } from 'lodash'

import Card from '../../card'
import SearchCustomized from '../../SearchCustomized'

import { NEWS_LIST_QUERY_CUSTOM } from '../../../../api/bantrab/queries'
import { getNews } from '../../../../api/bantrab'
import { useBreakpoint } from '../../../../hooks/breakpoint'

const List = ({ items, meta, id, fetchNews, ...attrs }) => {
  const breakpoint = useBreakpoint()

  const [isEditing, setEditing] = useState(false)
  const [itemsList, setItemsList] = useState(items || [], [items])

  useEffect(_ => {
    setItemsList(items)
  }, [items])

  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'md:pt-24',
      'md:pb-12',
      'pt-20',
      'pb-10'
    ]
  )

  const _handleGetBlogData = async (search) => {
    try {
      if (!search) {
        setItemsList(items)
        return
      }

      let response = await getNews(NEWS_LIST_QUERY_CUSTOM({ search }))

      response = await response.json() || {}

      const { items: itemsResponse } = response

      setItemsList(itemsResponse)
    } catch (error) {
      setItemsList(items)
    }
  }

  return (
    <section {...attrs}>
      <div
        className={
          classNames([
            'relative',
            'container',
            'px-4'
          ])
        }>
        <div className="md:flex md:justify-end mx-auto mb-10">
          <SearchCustomized
            isEditing={isEditing}
            onSearch={_handleGetBlogData}
            onEditing={setEditing} />
        </div>
        <div
          className={classNames([
            'grid',
            'grid-cols-2',
            'gap-8',
            'mb-10'
          ])}>
          {
            itemsList
              ? itemsList.map((item, key) => {
                return (
                  <Card.CardBigDefault
                    key={`blog-${key + 1}`}
                    title={item.title}
                    text={item.excerpt}
                    slug={item.meta.slug}
                    time={item.readingTime}
                    category={item.newsCategories.length > 0 ? item.newsCategories[0].category.name : null}
                    author={item.newsAuthors.length > 0 ? item.newsAuthors[0].author.fullName : null}
                    date={moment(item.meta.firstPublishedAt).format('DD/MM/YYYY')}
                    url={`/blog/${item.id}/${item.meta.slug}`}
                    image={get(item, 'headerImage.meta.downloadUrl', null)}
                    className="w-full"
                  />
                )
              })
              : null
          }
        </div>
        {
          items.length < meta.totalCount
            ? <div
              className={
                classNames([
                  'w-full',
                  'flex',
                  'flex-row',
                  'justify-center',
                  'text-center',
                  'border',
                  'border-red-500',
                  'text-red-500',
                  'py-3',
                  'mx-auto',
                  'cursor-pointer',
                  'hover:border-red-400',
                  'hover:text-red-400',
                  'active:border-red-600',
                  'active:text-red-600'
                ])
              }
              style={{
                maxWidth: breakpoint.mdAndUp ? '240px' : '320px',
                borderRadius: '0 1.5rem 1.5rem 1.5rem'
              }}
              onClick={fetchNews}>
              Ver más
            </div>
            : ''
        }
      </div>
    </section >
  )
}

List.propTypes = {
  items: PropTypes.array,
  meta: PropTypes.object,
  id: PropTypes.string,
  fetchNews: PropTypes.func
}

export default List
